import app from './main'

export default {
  app
}
